import { Collections, TeamTag, TeamTagEntity } from '@uploadcam/common';
import { addDoc, Firestore } from 'firebase/firestore';
import { getCollectionRef } from '../../../../@harmony/angular';

export class CreateTeamTagInteractor {
  constructor(private readonly db: Firestore) {}

  public async execute(teamId: string, name: string, isActive: boolean): Promise<TeamTag> {
    const collection = getCollectionRef<TeamTagEntity>(
      this.db,
      Collections.TeamTags.replace('{id}', teamId),
    );

    const entity: TeamTagEntity = {
      name: name.trim(),
      isActive,
    };

    const docRef = await addDoc(collection, entity);

    return new TeamTag(docRef.id, entity.name, entity.isActive);
  }
}
